var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArcDiagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 29C33 25.5522 31.7884 22.2456 29.6317 19.8076C27.4751 17.3696 24.55 16 21.5 16C18.45 16 15.5249 17.3696 13.3683 19.8076C11.2116 22.2456 10 25.5522 10 29H11.1479C11.1479 25.8963 12.2386 22.9198 14.18 20.7252C16.1214 18.5306 18.7545 17.2977 21.5 17.2977C24.2455 17.2977 26.8786 18.5306 28.82 20.7252C30.7614 22.9198 31.8521 25.8963 31.8521 29H33Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29C55 25.5522 53.7884 22.2456 51.6317 19.8076C49.4751 17.3696 46.55 16 43.5 16C40.45 16 37.5249 17.3696 35.3683 19.8076C33.2116 22.2456 32 25.5522 32 29H33.1479C33.1479 25.8963 34.2386 22.9198 36.18 20.7252C38.1214 18.5306 40.7545 17.2977 43.5 17.2977C46.2455 17.2977 48.8786 18.5306 50.82 20.7252C52.7614 22.9198 53.8521 25.8963 53.8521 29H55Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 40C13.3137 40 16 37.3137 16 34C16 30.6863 13.3137 28 10 28C6.68629 28 4 30.6863 4 34C4 37.3137 6.68629 40 10 40Z",
    fill: "#2B6299"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 40C36.3137 40 39 37.3137 39 34C39 30.6863 36.3137 28 33 28C29.6863 28 27 30.6863 27 34C27 37.3137 29.6863 40 33 40Z",
    fill: "#3B82C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40C58.3137 40 61 37.3137 61 34C61 30.6863 58.3137 28 55 28C51.6863 28 49 30.6863 49 34C49 37.3137 51.6863 40 55 40Z",
    fill: "#8CBFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcDiagram);
export default __webpack_public_path__ + "static/media/arc_diagram.09532aa2.svg";
export { ForwardRef as ReactComponent };